/* eslint-disable max-len */
import React from "react";

/**
 * A functional React component that renders a Radio SVG icon UI element.
 */
export const IconRadio: React.FC<{ isSelected?: boolean }> = ({ isSelected }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8.5" fill="white" stroke="#BEC2CA" />
        {isSelected && (
            <circle cx="9" cy="9" r="5" fill="#1D2D5A" />
        )}
    </svg>
);
